import getClient from '../../react-commons/utils/graphql';
import { CreateOrderCartMutation } from '../gql';
import { ReferenceLabelType } from '../types';

export interface OrderCart {
  id: string;
}

export interface SurveyData {
  apartmentSize?: number;
  receptionDate?: string;
  hasLegalInsurance?: boolean;
  householdMembers?: number;
  landlord?: string;
  legalInsurance?: string;
  periodMonthFrom?: number;
  periodMonthTo?: number;
  periodYearFrom?: number;
  periodYearTo?: number;
  postalCode?: string;
  rent?: number;
  balance?: number;
  businessType?: string;
  integratedPartnerId?: string;
}

export interface CreateOrderCartRequest {
  productId: string;
  referenceLabelType?: ReferenceLabelType;
  survey?: SurveyData;
  reference?: string;
  affiliatePartnerId?: string;
  state?: string | null;
  billingConsentTimestamp?: string | null;
  unionOptionsConsentTimestamp?: string | null;
  variant?: string | null;
}

export default {
  createOrderCart(request: CreateOrderCartRequest): Promise<OrderCart> {
    return getClient()
      .runMutation(CreateOrderCartMutation, { input: request })
      .then((res: any) => res.CreateOrderCart)
      .catch((error: any) => {
        if (error?.response?.errors?.[0]?.errorType === 'InvalidReference') {
          throw Error(error.response.errors[0].message, { cause: 'INVALID_REFERENCE' });
        }
        throw error;
      });
  },
};
